import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import Sparkline from '../../../components/Sparklines';

export const COLUMNS = (total_clicks = 1, t) => [
    {
        label: t('search.directories.table.first_directory'),
        key: 'first_directory',
        data: 'first_directory',
        Component: Cell,
        renderCell: ({ data, item, csvDownload }) => {
            if (csvDownload) return data;
            return (
                <strong>
                    <a
                        href={`/domains/${
                            window.info.id
                        }/gsc-reports/directories/directory?directory=${data ?? '/'}&subdomain=${
                            item.subdomain ?? '/'
                        }`}
                        className="d-inline-flex align-items-center justify-content-center"
                        rel="noreferrer"
                    >
                        {data ?? '/'}
                    </a>
                </strong>
            );
        },
    },
    {
        label: t('search.directories.table.subdomain'),
        key: 'subdomain',
        data: 'subdomain',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{data || '-'}</strong>;
        },
    },
    {
        label: t('search.directories.table.traffic_share'),
        key: 'traffic_share',
        data: 'traffic_share',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.clicks / total_clicks;
            return <strong>{numeral(item.clicks / total_clicks).format('0.00%')}</strong>;
        },
    },
    {
        label: t('search.directories.table.avg_weekly_urls'),
        key: 'urls',
        data: 'urls',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories.table.avg_weekly_keywords'),
        key: 'keywords',
        data: 'keywords',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories.table.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories.table.trend'),
        key: 'clicks_sparkline',
        data: 'clicks_sparkline',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return '-';
            return (
                <Sparkline
                    dataL={item.clicksL}
                    keyName="Clicks"
                    labels={item.weeksL.map((x) => x.value)}
                />
            );
        },
    },
    {
        label: t('search.directories.table.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories.table.avg_position'),
        key: 'position',
        data: 'position',
        Component: Cell,
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;
            return <strong>{numeral(data).format('0.0a')}</strong>;
        },
    },
    {
        label: t('search.directories.table.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        renderCell: ({ item, csvDownload }) => {
            if (csvDownload) return item.clicks / item.impressions;
            return (
                <div>
                    <strong>{numeral(item.clicks / item.impressions).format('0.00%')}</strong>
                </div>
            );
        },
    },
];
